import { RefObject, useRef } from 'react';

/**
 * Creates ref that never changes but always points to the latest value
 * @param value Latest value
 */
export function useCurrentRef<T>(value: T): RefObject<T> {
  const ref = useRef(value);
  // eslint-disable-next-line react-hooks/refs
  ref.current = value;
  return ref;
}
